<partial-loading-indicator #loadingIndicator>

  <div class="reset-password_header">
    <span>{{'components.reset-password-page.reset_password_page_title' | l10n}}</span>
  </div>

  <div class="reset-password_body">
    @switch (state) {
      @case (ResetPasswordPageState.FORM) {
        <form [formGroup]="form" (submit)="submit($event)">
          <div class="reset-password_instructions">{{'components.reset-password-page.form_instructions' | l10n}}</div>
          <div class="reset-password_field">
            <input type="text" class="reset-password_field_input"
              placeholder="{{'components.reset-password-page.form_input_user_id' | l10n}}"
              [formControl]="form.controls.login"
              autofocus
              materialInput />
          </div>
          <div class="reset-password_error-message">
            {{formErrors?.commonError | l10n}}
          </div>
          <div class="reset-password_footer-wrapper">
            <button class="reset-password_submit-button" type="submit" [disabled]="loadingIndicator.getLoadingState()">
              <span class="reset-password_submit-button_text">{{'components.reset-password-page.submit_form_button' | l10n}}</span>
            </button>
            <ng-container *ngTemplateOutlet="backToLoginButton"></ng-container>
          </div>
        </form>
      }
      @case (ResetPasswordPageState.SUCCESS) {
        <div class="reset-password_success-info">
          {{'components.reset-password-page.success_text_paragraph_1' | l10n:successMessageSubstitutions}}
        </div>
        <div class="reset-password_success-info">
          {{'components.reset-password-page.success_text_paragraph_2' | l10n:successMessageSubstitutions}}
        </div>
        <div class="reset-password_success-info">
          {{'components.reset-password-page.success_user_id' | l10n:successMessageSubstitutions}}
        </div>
        <div class="reset-password_submit-wrapper">
          <ng-container *ngTemplateOutlet="backToLoginButton"></ng-container>
        </div>
      }
    }
  </div>

</partial-loading-indicator>

<ng-template #backToLoginButton>
  <div class="reset-password_back-link-wrapper">
    <a class="reset-password_back-link" [routerLink]="['/login']">{{'components.reset-password-page.back_to_login' | l10n}}</a>
  </div>
</ng-template>
